import React from "react";

import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import ProfessionalProfileQuestionList from "./question.list";
import ProgressBar from "../../progress-bar/progress.bar";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {ProfessionalProfileRoutes, SiteMapRoutes} from "../../stores/site.map";
import QuestionnaireAutofillPanel from "../questionnaire-autofill/questionnaire.autofill.panel";
import {QuestionnaireTypeProps} from "../../common/with.questionnaire.type";
import LoadingOverlay from "../../loading-overlay/loading.overlay";
import QuestionnaireHeader from "./questionnaire.header";

type Props = {appStore?: AppStore} & RouteComponentProps & QuestionnaireTypeProps;

@useAppStore()
class Questionnaire extends React.Component<Props> {
	private questionnaireStore = this.props.appStore.questionnaireStore;
	private userStore = this.props.appStore.userStore;

	async componentDidMount() {
		await this.questionnaireStore.getQuestionnaire(this.props.questionnaireType);
	}

	private submitQuestionnaire = async () => {
		const pendingAnswerSheetId = await this.questionnaireStore.submitQuestionnaire(this.props.questionnaireType);
		if (!pendingAnswerSheetId) {
			this.userStore.setHasSubmittedQuestionnaire();
		} else {
			// save pendingAnswerSheetId to session storage
			window.sessionStorage.setItem("pendingAnswerSheetId", pendingAnswerSheetId);
		}

		const redirectTo = pendingAnswerSheetId ? {pathname: SiteMapRoutes.Login, state: {pendingAnswerSheetId: pendingAnswerSheetId}} : {pathname: ProfessionalProfileRoutes.ReportV2};
		this.props.history.push(redirectTo);
		this.questionnaireStore.clearQuestionnaire();
	};

	render() {
		const questionnaire = this.props.appStore.questionnaireStore.questionnaire;

		if (this.questionnaireStore.isQuestionnaireLoading) {
			return <LoadingOverlay message="Questionnaire Loading..." />;
		}

		return (
			<div className="cih-layout">
				<div className="container cih-questionnaire">
					<QuestionnaireHeader />
					<div className="cih-questionnaire-header">
						<div className="cih-instruction">{questionnaire.instructions}</div>
						<ProgressBar max={this.questionnaireStore.questionsCount} answered={this.questionnaireStore.answeredCount} />
					</div>
					<ProfessionalProfileQuestionList questions={questionnaire.questions} />
					<div className="cih-flex cih-justify-end cih-py-3 cih-px-2">
						<button
							className="arrowbutton __transparent"
							disabled={!this.questionnaireStore.isEveryQuestionAnswered || this.questionnaireStore.isQuestionnaireSubmitLoading}
							onClick={this.submitQuestionnaire}
						>
							<span className="buttontext">Submit responses</span>
							<span className="buttonicon">
								<span className="buttonicon-topline"></span>
								<span className="buttonicon-middleline"></span>
								<span className="buttonicon-bottomline"></span>
							</span>
						</button>
					</div>
					{this.props.appStore.configuration.isDebugPanelEnabled && <QuestionnaireAutofillPanel questions={questionnaire.questions} onSubmit={this.submitQuestionnaire} />}
				</div>
			</div>
		);
	}
}

export default withRouter(Questionnaire);
